'use strict';

var crypto = require('libp2p-crypto');

var bs58 = require('bs58');

exports = module.exports;
/**
 * Generatea random sequence number.
 *
 * @returns {Buffer}
 * @private
 */

exports.randomSeqno = function () {
  return crypto.randomBytes(20);
};
/**
 * Generate a message id, based on the `from` and `seqno`.
 *
 * @param {string} from
 * @param {Buffer} seqno
 * @returns {string}
 * @private
 */


exports.msgId = function (from, seqno) {
  return from + seqno.toString('hex');
};
/**
 * Check if any member of the first set is also a member
 * of the second set.
 *
 * @param {Set|Array} a
 * @param {Set|Array} b
 * @returns {boolean}
 * @private
 */


exports.anyMatch = function (a, b) {
  var bHas;

  if (Array.isArray(b)) {
    bHas = function bHas(val) {
      return b.indexOf(val) > -1;
    };
  } else {
    bHas = function bHas(val) {
      return b.has(val);
    };
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var val = _step.value;

      if (bHas(val)) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
};
/**
 * Make everything an array.
 *
 * @param {any} maybeArray
 * @returns {Array}
 * @private
 */


exports.ensureArray = function (maybeArray) {
  if (!Array.isArray(maybeArray)) {
    return [maybeArray];
  }

  return maybeArray;
};

exports.normalizeInRpcMessages = function (messages) {
  if (!messages) {
    return messages;
  }

  return messages.map(function (msg) {
    var m = Object.assign({}, msg);

    if (Buffer.isBuffer(msg.from)) {
      m.from = bs58.encode(msg.from);
    }

    return m;
  });
};

exports.normalizeOutRpcMessages = function (messages) {
  if (!messages) {
    return messages;
  }

  return messages.map(function (msg) {
    var m = Object.assign({}, msg);

    if (typeof msg.from === 'string' || msg.from instanceof String) {
      m.from = bs58.decode(msg.from);
    }

    return m;
  });
};